export default __webpack_public_path__ + "static/assets/683a168bd0f8b3ae87fd6a0c36acd0a3.png";